<ng-container *ngIf="!GetDisabledValue()">
  <nz-date-picker *ngIf="dataset[row][colData.Name] !== undefined"
    [(ngModel)]="dataset[row][colData.Name]" [nzDateRender]="tplRender" (ngModelChange)="valueChanged($event);">
  </nz-date-picker>
  <ng-template #tplRender let-current>
    <div class="ant-picker-cell-inner" [class.border]="current.getDate() === 1">
      {{ current.getDate() }}
    </div>
  </ng-template>
</ng-container>
<ng-container *ngIf="GetDisabledValue()">
  {{value}}
</ng-container>
